import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CopyIcon, RowsContainer, ShareIcon } from '@streamr/tv-ui';
import styled, { css } from 'styled-components';
import { useShare } from '../../../hooks/useShare';
import { copyToClipboard } from '../../../utils/copyToClipboard';
import { Popup, TopCenter, } from '../../../utils/popups';
import { formBroadcastUrl } from '../../../utils/url';
import { AbstractPopup, DismissalReason, } from '../AbstractPopup';
import { ScrollablePopupContainer } from '../helpers/ScrollablePopupContainer';
import { PopupCssPreset } from '../Popup.styles';
import { showToast } from '../ToastPopup';
const StopRecordingPopup = ({ reject, resolve, positioning, broadcast, isPublic, ...props }) => {
    const { canShare, openSystemShareDialog } = useShare();
    const link = formBroadcastUrl(broadcast, '/recordings');
    return (_jsx(StopRecordingPopupRoot, { reject: reject, ...props, translateFn: positioning.translateFn || TopCenter, "$popupCssPresetForDesktop": positioning.popupCssPresetForDesktop, children: _jsx(ScrollablePopupContainer, { fullscreenOnly: positioning.fullscreenOnly, onCloseButtonClick: () => {
                reject(DismissalReason.CloseButton);
            }, children: _jsxs(RowsContainer, { children: [_jsx(Title, { children: "Stop Recording?" }), _jsxs(InfoText, { children: ["This recording is ", isPublic ? 'public' : 'private', " and accessible via this link."] }), _jsx(Separator, {}), _jsxs(LinkSection, { children: [_jsx(LinkContent, { children: link }), _jsxs(LinkGroup, { children: [_jsx(LinkButton, { type: "button", onClick: () => {
                                            copyToClipboard(link);
                                            showToast('Link copied to clipboard!');
                                        }, children: _jsx(CopyIcon, {}) }), canShare && (_jsx(LinkButton, { type: "button", onClick: () => {
                                            openSystemShareDialog(link);
                                        }, children: _jsx(ShareIcon, {}) }))] })] }), _jsx(Separator, {}), _jsx(CTAButton, { "$confirm": false, type: "button", onClick: () => {
                            resolve(false);
                        }, children: "Cancel" }), _jsx(CTAButton, { "$confirm": true, type: "button", onClick: () => {
                            resolve(true);
                        }, children: "Stop Recording" })] }) }) }));
};
const StopRecordingPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};
    --Popup_Padding: 0;
    --SettingsContainer_InnerMaxWidth: 25rem;

    ${({ $popupCssPresetForDesktop }) => {
    if ($popupCssPresetForDesktop) {
        return css `
                @media (min-width: 30rem) {
                    ${$popupCssPresetForDesktop};
                    --Popup_Height: auto;
                    --Popup_Width: 25rem;
                    --Popup_Padding: 1rem 0;
                    --Popup_BorderRadius: var(--tv-ui-border-radius-2);
                }
            `;
    }
}};
`;
const Title = styled.h3 `
    font-size: 1.125rem;
    font-weight: 500;
    text-align: center;
`;
const InfoText = styled.p `
    font-size: 1rem;
    color: var(--tv-ui-color-2);
    text-align: center;
    max-width: 80%;
    margin: 0 auto;
    line-height: 1.5rem;
`;
const Separator = styled.div `
    width: 100%;
    height: 1px;
    background-color: var(--tv-ui-color-5);
`;
const LinkGroup = styled.div `
    display: flex;    
    gap: 0.5rem;
`;
const LinkSection = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
`;
const LinkContent = styled.span `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
`;
const LinkButton = styled(Button) `
    --Button_Transform: translate(0);
    --Button_HoverTransform: translate(0);
    --Button_ActiveTransform: translate(0);
    --Button_Padding: 0.5rem;
`;
const CTAButton = styled(Button) `
    width: 100%;
    padding: 1rem 0;
    --Button_Background: ${({ $confirm }) => ($confirm ? 'var(--tv-ui-color-3)' : 'transparent')};
    --Button_TextColor: ${({ $confirm }) => ($confirm ? 'var(--tv-ui-color-1)' : 'var(--tv-ui-color-3)')};
    --Button_BorderRadius: 1rem;
    --Button_Transform: translate(0);
    --Button_HoverTransform: scale(1.02);
    --Button_ActiveTransform: scale(1.02);
`;
const stopRecordingPopup = Popup.create(StopRecordingPopup);
export async function showStopRecordingPopup({ anchorRef, positioning, onBeforeOpen, onDismiss, broadcast, isPublic, }) {
    try {
        onBeforeOpen?.();
        return await stopRecordingPopup.pop({
            anchorRef,
            positioning,
            broadcast,
            isPublic,
        });
    }
    catch (_) {
    }
    finally {
        onDismiss?.();
    }
}
